// Display Home Location Panel
// - Custom Into Place map marker (Leaflet)
// - Intersection observer fade-in

(function () {
    'use strict';

    // Custom marker SVG (Into Place branded pin)
    var MARKER_SVG = '<svg width="40" height="52" viewBox="0 0 40 52" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 0C8.954 0 0 8.954 0 20c0 14.667 18.167 30.37 18.94 31.047a1.667 1.667 0 0 0 2.12 0C21.833 50.37 40 34.667 40 20 40 8.954 31.046 0 20 0zm0 27a8 8 0 1 0 0-16 8 8 0 0 0 0 16z" fill="#1E384B"/>' +
        '</svg>';

    /**
     * Build popup HTML from data attributes on the map container
     */
    function getPopupContent() {
        var container = document.querySelector('[data-location-map]');
        if (!container) return null;

        var title = container.dataset.locationTitle || '';
        var address = container.dataset.locationAddress || '';

        if (!title && !address) return null;

        var html = '<div class="location-marker-popup">';
        if (title) html += '<strong class="location-marker-popup__title">' + title + '</strong>';
        if (address) html += '<p class="location-marker-popup__address">' + address + '</p>';
        html += '</div>';

        return html;
    }

    /**
     * Replace the default Leaflet marker with our custom Into Place marker
     * and bind a popup with the entry title and address
     */
    function applyCustomMarker() {
        if (typeof displayHomeLocationMap === 'undefined') return false;
        if (typeof L === 'undefined') return false;
        if (!displayHomeLocationMap._markers || !displayHomeLocationMap._markers.length) return false;

        var customIcon = L.divIcon({
            html: MARKER_SVG,
            iconSize: [40, 52],
            iconAnchor: [20, 52],
            className: 'location-custom-marker',
        });

        var popupContent = getPopupContent();

        displayHomeLocationMap._markers.forEach(function (marker) {
            marker.setIcon(customIcon);

            if (popupContent) {
                marker.bindPopup(popupContent, {
                    offset: [0, -40],
                    className: 'location-popup',
                    closeButton: true,
                    maxWidth: 260,
                    minWidth: 160,
                });
            }
        });

        return true;
    }

    /**
     * Trigger Leaflet map invalidateSize to fix tile rendering
     */
    function resizeMap() {
        if (typeof displayHomeLocationMap !== 'undefined' && displayHomeLocationMap.invalidateSize) {
            displayHomeLocationMap.invalidateSize();
        }
    }

    /**
     * Fade-in on scroll via IntersectionObserver
     */
    function initFadeIn() {
        var panel = document.querySelector('.display-home-location-panel [data-panel-fade]');
        if (!panel) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    panel.dataset.panelFade = 'true';
                    observer.unobserve(entry.target);

                    // Trigger map resize after fade-in completes
                    setTimeout(resizeMap, 800);
                }
            });
        }, { threshold: 0.15 });

        observer.observe(panel);
    }

    /**
     * Reset map to original center and zoom
     */
    function initResetButton() {
        var resetButtons = document.querySelectorAll('[data-map-reset]');
        if (!resetButtons.length) return;

        resetButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (typeof displayHomeLocationMap === 'undefined') return;
                if (!displayHomeLocationMap._markers || !displayHomeLocationMap._markers.length) return;

                var marker = displayHomeLocationMap._markers[0];
                var latlng = marker.getLatLng();
                displayHomeLocationMap.setView(latlng, displayHomeLocationMap._initialZoom || 14, { animate: true });
            });
        });
    }

    /**
     * Store initial zoom level for reset
     */
    function storeInitialZoom() {
        if (typeof displayHomeLocationMap !== 'undefined' && displayHomeLocationMap.getZoom) {
            displayHomeLocationMap._initialZoom = displayHomeLocationMap.getZoom();
        }
    }

    /**
     * Wait for the Leaflet map to be initialized then apply custom marker
     */
    function init() {
        initFadeIn();

        var attempts = 0;
        var maxAttempts = 50;

        function tryApplyMarker() {
            if (applyCustomMarker()) {
                // Also fix tile sizing after marker is applied
                setTimeout(resizeMap, 100);
                storeInitialZoom();
                initResetButton();
                return;
            }
            attempts++;
            if (attempts < maxAttempts) {
                setTimeout(tryApplyMarker, 200);
            }
        }

        if (document.readyState === 'complete') {
            tryApplyMarker();
        } else {
            window.addEventListener('load', tryApplyMarker);
        }

        // Also resize map on window resize for responsive
        window.addEventListener('resize', resizeMap);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
